module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开启售后客服"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 60,
      "active-value": "true",
      "inactive-value": "false",
      "inactive-color": "#ccc",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.is_open),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_open", $$v)
      },
      expression: "form.is_open"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业 ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.form.enterprise_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "enterprise_id", $$v)
      },
      expression: "form.enterprise_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('a', {
    attrs: {
      "href": "https://app.meiqia.com/setting/id-query",
      "target": "_blank"
    }
  }, [_vm._v("企业ID地址")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客服组 ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.form.group_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "group_id", $$v)
      },
      expression: "form.group_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('a', {
    attrs: {
      "href": "https://app.meiqia.com/setting/id-query",
      "target": "_blank"
    }
  }, [_vm._v("客服组ID地址")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客服 ID"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.form.persion_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "persion_ids", $$v)
      },
      expression: "form.persion_ids"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_c('a', {
    attrs: {
      "href": "https://app.meiqia.com/setting/id-query",
      "target": "_blank"
    }
  }, [_vm._v("客服ID地址")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("售后客服保存")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-59cfc4e3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59cfc4e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/base/setting/im/backend.vue
// module id = 2743
// module chunks = 0